import type { JSX } from 'react';

import { AppRouter } from '@/app/router/routes';
import { Toaster } from '@/shared/ui/Toaster';

export function App(): JSX.Element {
  return (
    <>
      <AppRouter />
      <Toaster />
    </>
  );
}
